/* eslint-disable */
import inputEventBus from '@/mixins/input-eventbus';

export default {
    bind(el, binding) {
        const type = el.type;
        let value = el.value;
        let id = el.id;
        let category = el.dataset.category;

        if(binding.modifiers.radio || binding.modifiers.checkbox) {
            id = binding.value;
            value = '';
        } else if(binding.value !== undefined) {
            id = binding.value;
        }



        if(type === 'checkbox') {
            value = el.checked;
        }

        if(type === 'text' || type ==='textarea') {
            el.addEventListener('input', function() {
                value = this.value;
                inputEventBus.$emit('inputUpdated', value, id, el);
            });
        } else {
            el.addEventListener('change', function() {
                if(type === 'checkbox') {
                    value = el.checked;
                } else {
                    value = this.value;
                }
                inputEventBus.$emit('inputUpdated', value, id, el, category);
            });
        }

        if(!binding.modifiers.flagged) {
            inputEventBus.$emit('inputInit', value, id, el);
        } else {
            inputEventBus.$emit('inputInitFlagged', value, id, el);
        }

        inputEventBus.$on('inputCleared', () => {
            if(type === 'radio' || type === 'checkbox') {
                el.checked = false;
            } else {
                el.value = '';
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/input.js